// extracted by mini-css-extract-plugin
module.exports = {"team-socials":"Socials_team-socials__1z3An"};